import { forwardRef } from "react";
import { IMaskInput } from 'react-imask';

// Normaliza o valor recebido para o formato brasileiro (ex: 4498.73 -> "4.498,73")
// antes de entregar ao IMask. Sem isso, um number/string com ponto decimal
// (vindo de centsToReais) é interpretado pelo IMask como separador de milhar e
// o valor fica ~100x maior (4498.73 -> "449.873").
const toBrCurrencyString = (value) => {
    if (value == null || value === '') return '';

    if (typeof value === 'number') {
        return Number.isFinite(value)
            ? value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : '';
    }

    const text = String(value);

    // String numérica "pura" (sem vírgula), como "4498.73" ou "4500": trata como number
    if (/^-?\d+(\.\d+)?$/.test(text)) {
        return Number(text).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    // Já está no formato mascarado (ex: "4.498,73"): mantém como está
    return text;
};

const CurrencyMaskCustom = forwardRef(function CurrencyMaskCustom(props, ref) {
    const { onChange, value, ...other } = props;
    const stringValue = toBrCurrencyString(value);

    return (
        <IMaskInput
            {...other}
            value={stringValue}
            mask={Number}
            scale={2}
            thousandsSeparator="."
            radix=","
            mapToRadix={['.']}
            normalizeZeros
            min={0}
            inputRef={ref}
            onAccept={(nextValue) => onChange({ target: { name: props.name, value: nextValue } })}
            overwrite
        />
    );
});

export default CurrencyMaskCustom;

